//askSmart-ui/src/pages/ManageSMRTDocsWizard.tsx
import React from "react";
import SMRTDocsEditor from "./SMRTDocsEditor";

export default function ManageSMRTDocsWizard({
  service,
  setService,
  onClose,
}: {
  service: any;
  setService: (s: any) => void;
  onClose: () => void;
}) {
  return (
    <div style={{ minWidth: "900px" }}>
      <button
        className="btn-save"
        onClick={() => {
          console.log(service);
          onClose();
        }}
      >
        Save
      </button>

      <SMRTDocsEditor
        serviceName={service.name}
        setServiceName={(name: string) => setService({ ...service, name })}
        template={service.data}
        setTemplate={(data: any) => setService({ ...service, data })}
      />

      <button className="btn-cancel" onClick={onClose}>
        Cancel
      </button>
    </div>
  );
}
